import { render } from "./PosterGroup.vue?vue&type=template&id=b95dc360"
const script = {}

import "./PosterGroup.vue?vue&type=style&index=0&id=b95dc360&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__